import { render, staticRenderFns } from "./Laplacian.vue?vue&type=template&id=910762e6"
import script from "./Laplacian.vue?vue&type=script&lang=js"
export * from "./Laplacian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports